// Shared formatting for the Predictions quest.

export const RESOLUTION_LABELS = {
  YES: 'Happened',
  NO: 'Did not happen',
  VOID: 'Voided'
};

export function formatPercent(value, digits = 0) {
  if (value === null || value === undefined) return '—';
  return `${(value * 100).toFixed(digits)}%`;
}

export function formatBrier(value) {
  if (value === null || value === undefined) return '—';
  return value.toFixed(3);
}

export function formatDate(iso) {
  if (!iso) return null;
  const [year, month, day] = iso.split('-').map(Number);
  if (!year) return iso;
  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC'
  });
}

// "predictions made Jan 6, 2026 · graded Dec 20, 2025"
export function formatSetDates(set) {
  const parts = [];
  const made = formatDate(set.predictionsMadeOn);
  const evaluated = formatDate(set.evaluatedOn);
  if (made) parts.push(`written ${made}`);
  if (evaluated) parts.push(`graded ${evaluated}`);
  return parts.join(' · ');
}

// Set names are written for a page heading ("Dan 2020-2021"), not for a 60px axis slot. Sets that
// belong together are named alike, so whatever they all share carries no information on an axis
// where every tick has it: drop the shared prefix and what's left is the part that differs —
// `dan-2020-2021, dan-2022` → `2020-2021, 2022`, and `2026-W01 … 2026-W52` → `W01 … W52`.
//
// Deliberately not "pull the year out of the name": that reads well for annual sets and collapses
// fifty-two weekly ones onto the same label. The full name is always in the tooltip regardless.
const MAX_AXIS_LABEL = 14;

export function axisLabels(names) {
  if (names.length < 2) return names.map(clip);

  let prefix = names[0];
  for (const name of names.slice(1)) {
    let i = 0;
    while (i < prefix.length && i < name.length && prefix[i] === name[i]) i += 1;
    prefix = prefix.slice(0, i);
  }
  // Only cut at a separator, so "Q1"/"Q2" never becomes "1"/"2" by eating half a word.
  const cut = Math.max(prefix.lastIndexOf('-'), prefix.lastIndexOf(' '), prefix.lastIndexOf('_'));
  const shared = cut > 0 ? prefix.slice(0, cut + 1) : '';

  const stripped = names.map(name => name.slice(shared.length));
  // If stripping empties any label it told them apart after all — keep the names whole.
  return (stripped.every(Boolean) ? stripped : names).map(clip);
}

function clip(name) {
  return name.length > MAX_AXIS_LABEL ? `${name.slice(0, MAX_AXIS_LABEL - 1)}…` : name;
}

// Probabilities are offered in ten-point increments only — the granularity these predictions have
// always been written at, and fine enough that calibration buckets stay populated.
export const PROBABILITY_STEP = 10;
